import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbars from "./components/Navbars";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Feedback from "./pages/Feedback";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ContactUs from "./pages/ContactUs";
import ProductDetails from "./pages/ProductDetails";
import { ToastNotification } from "./pages/ToastNotification";
import TermsAndConditions from './pages/TermsAndConditions';
import { AuthProvider } from "./utils/AuthContext";
import OrderPage from "./pages/OrderPage";
import Cart from "./pages/Cart";
import PaymentSuccess from "./components/PaymentSuccess";
import CheckoutPage from "./components/CheckoutPage";

const App = () => {
  return (
    <AuthProvider>
    <Router>
      <ToastNotification/>
      <Navbars/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/privacy-and-policy" element={<PrivacyPolicy />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/order" element={<OrderPage />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/product/:id" element={<ProductDetails />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/checkout/:productId" element={<CheckoutPage />} />
        

      </Routes>
      <Footer /> {/* Render Footer globally */}
    </Router>
    </AuthProvider>
  );
};

export default App;
